/**
 * @param {object} props
 * @param {string} props.primaryColor
 * @param {string} props.secondaryColor
 * @param {boolean} props.hideChevrons
 */
function AdvisorSvg({ primaryColor, secondaryColor, hideChevrons, advisorImage }) {
    return (
        <svg
            viewBox="0 0 689 649"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            {!hideChevrons && (
                <>
                    <mask
                        id="mask0_2056_10116"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="-2"
                        y="0"
                        width="554"
                        height="649"
                    >
                        <rect x="-2" width="554" height="649" fill="url(#paint0_linear_2056_10116)" />
                    </mask>
                    <g mask="url(#mask0_2056_10116)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M-19 0.551428C-23.125 0.718428 -27.512 1.08743 -28.75 1.37143L-31 1.88743V34.3774V66.8664L-28.25 70.1064C-25.675 73.1404 111.466 211.028 157.978 257.349C170.349 269.668 180.834 281.036 183.345 284.849C191.794 297.684 196 311.501 196 326.428C196 341.989 191.38 356.123 182.134 368.849C178.667 373.621 140.215 412.901 76.412 476.849C21.262 532.124 -25.467 579.099 -27.431 581.239L-31 585.129V616.428V647.726L-26.75 648.346C-24.412 648.687 32.4 649.052 99.5 649.157C231.195 649.364 226.085 649.54 240.989 644.279C246.803 642.226 259.633 636.053 261.247 634.531C261.936 633.881 265.65 630.788 269.5 627.658C276.093 622.299 354.483 543.995 474.533 422.849C524.65 372.275 527.75 368.939 531.203 361.849C538.433 347.006 539.364 342.984 539.414 326.349C539.451 314.333 539.092 310.255 537.614 305.849C535.132 298.453 528.352 284.704 525.183 280.642C522.293 276.938 270.582 25.0514 264.777 20.0544C262.729 18.2914 260.862 16.8494 260.627 16.8494C260.393 16.8494 258.018 15.3814 255.35 13.5874C248.735 9.13842 235.749 4.15543 224.687 1.82043C215.874 -0.0405746 210.878 -0.111578 102 0.0634217C39.575 0.164422 -14.875 0.383428 -19 0.551428Z"
                            fill="url(#paint1_linear_2056_10116)"
                        />
                    </g>
                    <mask
                        id="mask1_2056_10116"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="-252"
                        y="0"
                        width="573"
                        height="649"
                    >
                        <rect x="-252" width="573" height="649" fill="url(#paint2_linear_2056_10116)" />
                    </mask>
                    <g mask="url(#mask1_2056_10116)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M-240 0.551428C-244.125 0.718428 -248.512 1.08743 -249.75 1.37143L-252 1.88743V34.3774V66.8664L-249.25 70.1064C-246.675 73.1404 -109.534 211.028 -63.022 257.349C-50.651 269.668 -40.166 281.036 -37.655 284.849C-29.206 297.684 -25 311.501 -25 326.428C-25 341.989 -29.62 356.123 -38.866 368.849C-42.333 373.621 -80.785 412.901 -144.588 476.849C-199.738 532.124 -246.467 579.099 -248.431 581.239L-252 585.129V616.428V647.726L-247.75 648.346C-245.412 648.687 -188.6 649.052 -121.5 649.157C10.195 649.364 5.08501 649.54 19.989 644.279C25.803 642.226 38.633 636.053 40.247 634.531C40.936 633.881 44.65 630.788 48.5 627.658C55.093 622.299 133.483 543.995 253.533 422.849C303.65 372.275 306.75 368.939 310.203 361.849C317.433 347.006 318.364 342.984 318.414 326.349C318.451 314.333 318.092 310.255 316.614 305.849C314.132 298.453 307.352 284.704 304.183 280.642C301.293 276.938 49.582 25.0514 43.777 20.0544C41.729 18.2914 39.862 16.8494 39.627 16.8494C39.393 16.8494 37.018 15.3814 34.35 13.5874C27.735 9.13842 14.749 4.15543 3.68701 1.82043C-5.12599 -0.0405746 -10.122 -0.111578 -119 0.0634217C-181.425 0.164422 -235.875 0.383428 -240 0.551428Z"
                            fill="url(#paint3_linear_2056_10116)"
                        />
                    </g>
                </>
            )}
            <rect x="141" y="213" width="548" height="308" fill="url(#pattern0_2056_10116)" />
            <defs>
                <pattern id="pattern0_2056_10116" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use
                        xlinkHref="#image0_2056_10116"
                        transform="matrix(0.00115075 0 0 0.00204918 -0.120829 -0.606558)"
                    />
                </pattern>
                <linearGradient
                    id="paint0_linear_2056_10116"
                    x1="552"
                    y1="276.444"
                    x2="-2"
                    y2="276.444"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.04" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2056_10116"
                    x1="539"
                    y1="311.5"
                    x2="-31"
                    y2="311.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={secondaryColor} />
                    <stop offset="0.84" stopColor={primaryColor} />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2056_10116"
                    x1="321"
                    y1="276.444"
                    x2="-252"
                    y2="276.444"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.04" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2056_10116"
                    x1="318"
                    y1="311.5"
                    x2="-252"
                    y2="311.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={secondaryColor} />
                    <stop offset="0.84" stopColor={primaryColor} />
                </linearGradient>
                <image
                    id="image0_2056_10116"
                    width="1080"
                    height="1080"
                    xlinkHref={advisorImage}
                />
            </defs>
        </svg>
    );
}

export default AdvisorSvg;
